export default  class PollStatusManager {

  constructor(statusId, resource, statusEndPoint) {
    this.pollInterval = 5000;

    this.statusId = statusId;
    this.statusEndpoint = statusEndPoint;
    this.resource = resource;

    this.statusDiv = null;
    this.status = null;

    this.init()
  }

  init() {
    this.status = this.getStatus();
    if(!this.status) return;

    this.resourceId = this.getResourceId();
    if(!this.resourceId) return;

    this.statusEndpoint = this.statusEndpoint.replace(':id', this.resourceId);

    this.pollStatus()
  }

  getResourceId() {
    const match = window.location.pathname.match(new RegExp(`/${this.resource}/([^/]+)`));
    return match?.[1]
  }

  getStatus() {
    const statusElement = document.getElementById(this.statusId);
    if(!statusElement) return;

    const statusText = statusElement.innerText;
    if(!statusText) return;

    return statusText.toLowerCase()
  }

  async fetchStatus() {
    const response = await fetch(this.statusEndpoint);
    const data = await response.json();
    return data.status
  }

  async pollStatus() {
    const newStatus = await this.fetchStatus();
    if(newStatus && newStatus !== this.status) {
      window.location.reload()
    }

    if(this.status === 'completed') return;

    setTimeout(() => {
      this.pollStatus();
    }, this.pollInterval)
  }

}
